// extracted by mini-css-extract-plugin
export default {"pin-img":"pX362KVe3mN8Ym0aUknZ","popup":"hrPC4EZRSaTr7zn8XhNd"};